import { Link } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";

const Requestrow = ({ req }) => {
  const { API } = useStateContext();

  return (
    <tr>
      <td className="ps-4">
        <img src={`${API}${req.image}`} alt={req.name} className="rounded-circle" style={{ width: 44, height: 44, objectFit: "cover" }} />
      </td>
      <td>
        <div className="fw-semibold">{req.name}</div>
        <div className="text-muted small">{req.email}</div>
      </td>
      <td>{req.position || "—"}</td>
      <td>{req.nationality || "—"}</td>
      <td>
        <span className="badge rounded-pill bg-light text-dark">{req.role || "Guest"}</span>
      </td>
      <td className="pe-4">
        <Link to={`./${req.id}`} className="btn btn-sm btn-dark">
          Review
        </Link>
      </td>
    </tr>
  );
};

export default Requestrow;